// Carry Roll BagScreen — Screen 3. Gapping chart + recommendation rail.

import { Collapsible } from '../components/calculator/Collapsible';
import { GapChart } from '../components/bag/GapChart';
import { BagSetup } from '../components/bag/BagSetup';
import { FittingAssumptions } from '../components/bag/FittingAssumptions';
import { RecommendationRail } from '../components/bag/RecommendationRail';

export default function BagScreen() {
  return (
    <div className="measure flex flex-col gap-4" data-testid="bag-screen">
      <h2 className="section-title">
        Bag
      </h2>
      <Collapsible title="Bag setup" testId="bag-setup-section">
        <BagSetup />
      </Collapsible>
      <GapChart />
      <Collapsible title="Fitting assumptions" testId="fitting-assumptions-section" defaultOpen={false}>
        <FittingAssumptions />
      </Collapsible>
      <RecommendationRail />
    </div>
  );
}
